// extracted by mini-css-extract-plugin
module.exports = {"viewAllButton":"idt-viewallbutton_viewallbutton__36e4u","copy":"idt-viewallbutton_copy__1-prm","icon":"idt-viewallbutton_icon__3tlpn"};